import { styled } from "@mui/material";
import { useGoogleAnalyticsContext } from "contexts";
import { useLinks } from "hooks/useLinks";

const LogoWrap = styled("div")`
	display: inline-block;
`;

const LogoImage = styled("img")`
	margin-top: 6px;
	width: 20vw;
	max-width: 100px;
	content: url("https://cdn-a1.tripeaksapp.com/WebStore/static_assets/frontend/public/logo/tiki_solitaire_logo.png");
`;

const Logo = ({ id, className }: { id?: string; className?: string }) => {
	const { reportEvent } = useGoogleAnalyticsContext();
	const links = useLinks();

	const handleLogoClick = () => {
		window.scrollTo(0, 0);
		reportEvent(links.home.analytics_key, { source: "tripeaks_logo_header" });
	};

	return (
		<LogoWrap id={id} className={className}>
			<LogoImage onClick={handleLogoClick} />
		</LogoWrap>
	);
};

export default Logo;
